"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _View = _interopRequireDefault(require("@instructure/ui-layout/lib/components/View"));

var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));

var _ThemeablePropTypes = _interopRequireDefault(require("@instructure/ui-themeable/lib/utils/ThemeablePropTypes"));

var _passthroughProps = require("@instructure/ui-utils/lib/react/passthroughProps");

var _deprecated = _interopRequireDefault(require("@instructure/ui-utils/lib/react/deprecated"));

var _uiTestable = _interopRequireDefault(require("@instructure/ui-testable"));

var _theme = _interopRequireDefault(require("./theme"));

var _dec, _dec2, _dec3, _class, _class2, _temp;

var styles = {
  componentId: 'eQCNs',
  template: function template(theme) {
    return "\n\n.eQCNs_bGBk{border-collapse:collapse;border-spacing:0;color:".concat(theme.color || 'inherit', ";display:table;font-family:").concat(theme.fontFamily || 'inherit', ";font-size:").concat(theme.fontSize || 'inherit', ";font-weight:").concat(theme.fontWeight || 'inherit', ";max-width:100%;width:100%}\n\n.eQCNs_bGBk,.eQCNs_bGBk caption{background:").concat(theme.background || 'inherit', "}\n\n.eQCNs_bGBk caption{color:").concat(theme.captionColor || 'inherit', ";font-size:").concat(theme.captionFontSize || 'inherit', ";text-align:start}\n\n[dir=ltr] .eQCNs_bGBk caption{text-align:left}\n\n[dir=rtl] .eQCNs_bGBk caption{text-align:right}\n\n.eQCNs_bGBk td,.eQCNs_bGBk th,.eQCNs_bGBk tr{box-sizing:border-box}\n\n.eQCNs_bGBk td,.eQCNs_bGBk th{border-bottom-color:").concat(theme.borderColor || 'inherit', ";border-bottom-style:solid;border-bottom-width:0.0625rem;text-align:start;vertical-align:middle}\n\n[dir=ltr] .eQCNs_bGBk td,[dir=ltr] .eQCNs_bGBk th{text-align:left}\n\n[dir=rtl] .eQCNs_bGBk td,[dir=rtl] .eQCNs_bGBk th{text-align:right}\n\n.eQCNs_bGBk th{font-weight:700}\n\n.eQCNs_bGBk thead>th{border-bottom-color:").concat(theme.headerBorderColor || 'inherit', "}\n\n.eQCNs_doqw{font-size:").concat(theme.smallFontSize || 'inherit', "}\n\n.eQCNs_doqw td,.eQCNs_doqw th{line-height:").concat(theme.smallLineHeight || 'inherit', ";padding:").concat(theme.smallPadding || 'inherit', "}\n\n.eQCNs_ycrn{font-size:").concat(theme.mediumFontSize || 'inherit', "}\n\n.eQCNs_ycrn td,.eQCNs_ycrn th{line-height:").concat(theme.mediumLineHeight || 'inherit', ";padding:").concat(theme.mediumPadding || 'inherit', "}\n\n.eQCNs_cMDj{font-size:").concat(theme.largeFontSize || 'inherit', "}\n\n.eQCNs_cMDj td,.eQCNs_cMDj th{line-height:").concat(theme.largeLineHeight || 'inherit', ";padding:").concat(theme.largePadding || 'inherit', "}\n\n.eQCNs_bBWt>tbody>tr>td:nth-child(2n),.eQCNs_cWEh>tbody>tr:nth-child(odd){background-color:").concat(theme.stripedBackground || 'inherit', "}\n\n.eQCNs_fKeI>tbody>tr{border-left:0.1875rem solid transparent;border-right:0.1875rem solid transparent}\n\n.eQCNs_fKeI>tbody>tr:hover{border-color:").concat(theme.hoverBorderColor || 'inherit', "}\n\n.eQCNs_bvTK{table-layout:fixed}");
  },
  'root': 'eQCNs_bGBk',
  'small': 'eQCNs_doqw',
  'medium': 'eQCNs_ycrn',
  'large': 'eQCNs_cMDj',
  'colStriped': 'eQCNs_bBWt',
  'rowStriped': 'eQCNs_cWEh',
  'hover': 'eQCNs_fKeI',
  'fixedLayout': 'eQCNs_bvTK'
};

/**
---
category: components
---
**/
var Table = (_dec = (0, _uiTestable.default)(), _dec2 = (0, _deprecated.default)('3.0.0', {
  tableData: true,
  rowHeaders: true,
  colHeaders: true
}), _dec3 = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Table, _Component);

  function Table() {
    (0, _classCallCheck2.default)(this, Table);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Table).apply(this, arguments));
  }

  (0, _createClass2.default)(Table, [{
    key: "render",
    value: function render() {
      var _classes;

      var classes = (_classes = {}, (0, _defineProperty2.default)(_classes, styles.root, true), (0, _defineProperty2.default)(_classes, styles.fixedLayout, this.props.layout === 'fixed'), (0, _defineProperty2.default)(_classes, styles[this.props.size], true), (0, _defineProperty2.default)(_classes, styles.rowStriped, this.props.striped === 'rows'), (0, _defineProperty2.default)(_classes, styles.colStriped, this.props.striped === 'columns'), (0, _defineProperty2.default)(_classes, styles.hover, this.props.hover), _classes);

      var passthroughProps = _View.default.omitViewProps((0, _passthroughProps.omitProps)(this.props, Table.propTypes), Table);

      return _react.default.createElement(_View.default, Object.assign({}, passthroughProps, {
        elementRef: this.props.elementRef,
        as: "table",
        className: (0, _classnames.default)(classes),
        margin: this.props.margin
      }), _react.default.createElement("caption", null, this.props.caption), this.props.children);
    }
  }]);
  Table.displayName = "Table";
  return Table;
}(_react.Component), _class2.propTypes = {
  /**
  * Set the table's caption element (its label)
  */
  caption: _propTypes.default.node.isRequired,

  /**
  * Build the table markup via the children prop
  */
  children: _propTypes.default.node,

  /**
  * Highlight each row on hover
  */
  hover: _propTypes.default.bool,

  /**
  * Controls the padding and font-size of table cells
  */
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),

  /**
  * Add a light background color to alternate rows or columns
  */
  striped: _propTypes.default.oneOf(['columns', 'rows']),

  /**
  * Valid values are `0`, `none`, `auto`, `xxx-small`, `xx-small`, `x-small`,
  * `small`, `medium`, `large`, `x-large`, `xx-large`. Apply these values via
  * familiar CSS-like shorthand. For example: `margin="small auto large"`.
  */
  margin: _ThemeablePropTypes.default.spacing,

  /**
  * @deprecated
  */
  tableData: _propTypes.default.array,

  /**
  * @deprecated
  */
  colHeaders: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
  * @deprecated
  */
  rowHeaders: _propTypes.default.bool,

  /**
  * provides a reference to the underlying html element
  */
  elementRef: _propTypes.default.func,

  /**
  * `auto` lets the browser determine table column widths based on cell content,
  * while `fixed` forces columns of equal width.
  */
  layout: _propTypes.default.oneOf(['auto', 'fixed'])
}, _class2.defaultProps = {
  children: null,
  striped: void 0,
  margin: void 0,
  tableData: void 0,
  colHeaders: void 0,
  rowHeaders: void 0,
  elementRef: void 0,
  hover: false,
  size: 'medium',
  layout: 'auto'
}, _temp)) || _class) || _class) || _class);
var _default = Table;
exports.default = _default;